/*
// STEP 1: Get cart data

function getCartPermalink() {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (!cart.items || !cart.items.length) return null;

      return cart.items
        .map(item => `${item.variant_id}:${item.quantity}`)
        .join(',');
    })
    .catch(err => {
      console.error('Cart fetch error:', err);
      return null;
    });
}

// STEP 2: Generate & Copy link

function generateCartShareLink() {
  getCartPermalink().then(cartString => {
    if (!cartString) return;

    const shareURL = `${window.location.origin}/cart/${cartString}?storefront=true`;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(shareURL).then(() => {
        showCopyMessage();
      });
    }
  });
}

// STEP 3: Show message in div

function showCopyMessage() {
  const msgDiv = document.getElementById('cart-copy-msg');
  if (!msgDiv) return;

  msgDiv.style.display = 'block';

  setTimeout(() => {
    msgDiv.style.display = 'none';
  }, 3000); // 3 seconds baad hide
}

// STEP 4: Button Init

document.addEventListener('DOMContentLoaded', () => {
  const shareBtn = document.getElementById('share-cart-btn');
  if (shareBtn) {
    shareBtn.addEventListener('click', generateCartShareLink);
  }

  if (window.location.pathname.startsWith("/cart/") && window.location.pathname.length > 6) {
    window.location.replace(window.location.origin);
  }
}); */



/* ===============================
   Device Detection (iOS)
================================ */
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

/* ===============================
   Generate & Share Cart Link
================================ */
function generateCartShareLink() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (!cart.items || !cart.items.length) return;

      const cartString = cart.items
        .map(item => `${item.variant_id}:${item.quantity}`)
        .join(',');

      const shareURL = `${window.location.origin}/cart/${cartString}?storefront=true`;

      // iOS → Native Share API
      if (isIOS() && navigator.share) {
        navigator.share({
          title: 'My Cart',
          url: shareURL
        });
      }
      // Desktop / others → Clipboard
      else {
        copyToClipboard(shareURL);
      }
    })
    .catch(err => console.error('Cart fetch error:', err));
}

/* ===============================
   Clipboard Copy (Desktop)
================================ */
function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text)
      .then(showCopyMessage)
      .catch(() => fallbackCopy(text));
  } else {
    fallbackCopy(text);
  }
}

/* ===============================
   Clipboard Fallback
================================ */
function fallbackCopy(text) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';

  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  try {
    document.execCommand('copy');
    showCopyMessage();
  } catch (err) {
    console.error('Copy failed:', err);
  }

  document.body.removeChild(textarea);
}

/* ===============================
   Show "Copied" Message
================================ */
function showCopyMessage() {
  const msgDiv = document.getElementById('cart-copy-msg');
  if (!msgDiv) return;

  msgDiv.style.display = 'block';
  setTimeout(() => {
    msgDiv.style.display = 'none';
  }, 3000);
}

/* ===============================
   Init Button & Cleanup URL
================================ */
document.addEventListener('DOMContentLoaded', () => {
  const shareBtn = document.getElementById('share-cart-btn');
  if (shareBtn) {
    shareBtn.addEventListener('click', generateCartShareLink);
  }

  // Prevent cart permalink from staying in URL
  if (
    window.location.pathname.startsWith('/cart/') &&
    window.location.pathname.length > 6
  ) {
    window.location.replace(window.location.origin);
  }
});
